import useClickOutside from 'components/useClickOutSide';
import Icon from 'atoms/Icon';
import Text from 'atoms/Text';
import React, { useRef, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import ActionDropBox from './ActionDropBox';

function FilterDatePicker({
    label, name, watch, onRemove, setValue, maxDate, minDate
}) {
    const [showDatePicker, setShowDatePicker] = useState(false);
    const ref = useRef();

    useClickOutside(ref, () => setShowDatePicker(false));

    const actionButtons = [
        {
            label: 'Remove',
            kind: 'silent',
            onClick: onRemove
        },
        {
            label: 'Close',
            kind: 'secondaryLoud',
            onClick: () => setShowFilter(false),
            className: '!flex md:!hidden'
        },
        {
            label: 'Ok',
            onClick: () => {
                setShowDatePicker(false);
            },
            isDisabled: !Boolean(watch(name))
        }
    ];

    return (
        <div className='relative'>
            <div
                className='border max-w-[200px] bg-white border-gray-200 px-2 h-8 text-xs flex justify-between items-center gap-3 cursor-pointer'
                onClick={() => setShowDatePicker(!showDatePicker)}
            >
                <Text className='truncate' title={moment(watch(name)).format('MM/DD/YYYY')} variant='label'>{label}: {watch(name) ? moment(watch(name)).format('MM/DD/YYYY'): ''}</Text>
                <Icon icon='calendar__l__stroke' size='w-3 h-3' />
            </div>
            {
                showDatePicker && (
                    <div ref={ref}>
                        <ActionDropBox
                            label={label}
                            onClose={() => setShowDatePicker(false)}
                            buttons={actionButtons}
                            height="h-screen md:h-auto md:max-h-[400px]"
                        >
                            <Calendar
                                value={watch(name)}
                                onChange={(date) => setValue(name, date)}
                                formatShortWeekday={(locale, date) => moment(date).format('dd').charAt(0)}
                                className='calendar-custom'
                                maxDate={maxDate}
                                minDate={minDate}
                                prevLabel={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M497.137 511.996l210.743-210.746-90.508-90.509-301.255 301.255 301.255 301.256 90.508-90.509-210.743-210.747z "></path></svg>}
                                nextLabel={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M526.863 511.996l-210.745-210.746 90.509-90.509 301.256 301.255-301.256 301.256-90.509-90.509 210.745-210.747z "></path></svg>}
                            />
                        </ActionDropBox>
                    </div>
                )
            }
        </div>
    );
}

export default FilterDatePicker;
